export default "__VITE_ASSET__Dc$xwEmS__"